import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { handle } from './wrapper.js'
import * as utilities from '#utilities/js/styles.js'

const quantities = object(null, {
  1: 'new_p1_xdays',
  2: 'new_p2_xweeks',
  3: 'new_p3_xmonths'
})
const handler = async (select, wrapper) => {
  const period = one('[name="new_period"]', wrapper)
  const fieldsets = all(`.ea_calendar__event_repeat__frequency_fieldset`, wrapper)
  const quantityFieldRequired = one(`[name="${quantities[select.value]}"]`, wrapper)

  period.value = select.value

  for (const fieldset of fieldsets) {
    fieldset.classList.add(utilities.modifiers.display.none)
  }

  fieldsets[select.value - 1].classList.remove(utilities.modifiers.display.none)

  for (const [, name] of Object.entries(quantities)) {
    let quantityField = one(`[name="${name}"]`, wrapper)
    quantityField.removeAttribute('required')
  }

  if (quantityFieldRequired) {
    quantityFieldRequired.required = true
  }
}

export default select => {
  handle(select, handler)
}
